module.exports = __webpack_public_path__ + "media/images/flags/lc-46ec9f4c0e3773cd3789f534111b0f4b.svg";